import WebSocketClient from '@clients/web-socket.client';

const socket = WebSocketClient.getInstance();

export function readArticle(data: number) {

  socket.sendJSON({
    readArticle: data,
  });
}





// WEBPACK FOOTER //
// ./src/services/article/article.websocket.ts